import { toEditorHtml } from "./mailUtils";

export const SIGNATURE_MAX_LENGTH = 200000;
export const SIGNATURE_LABEL_MAX_LENGTH = 128;
export const DEFAULT_SIGNATURE_LABEL = "Default signature";

export function buildSignatureHtml(signature = "") {
  const trimmed = (signature || "").trim();
  if (!trimmed) return "";
  const body = toEditorHtml(trimmed);
  return `<div class="mail-signature">--<br>${body}</div>`;
}

export function toSignatureRecord(input, index = 0) {
  const rawId = input?.id;
  const id = rawId === null || rawId === undefined ? `sig-${index + 1}` : rawId;
  const rawLabel = typeof input?.label === "string" ? input.label.trim() : "";
  const fallbackById = typeof id === "number" ? `Signature ${id}` : `Signature ${index + 1}`;
  const label = rawLabel || fallbackById;
  const content = typeof input?.content === "string" ? input.content.slice(0, SIGNATURE_MAX_LENGTH) : "";
  return {
    id,
    label,
    content,
    isDefault: Boolean(input?.isDefault),
  };
}

export function normalizeSignatureList(rawSignatures, fallbackContent = "") {
  const list = Array.isArray(rawSignatures)
    ? rawSignatures.map((entry, index) => toSignatureRecord(entry, index)).filter((entry) => entry.id !== null)
    : [];

  const baseContent = typeof fallbackContent === "string" ? fallbackContent.trim() : "";
  if (!list.length && baseContent) {
    list.push({
      id: "sig-default",
      label: DEFAULT_SIGNATURE_LABEL,
      content: baseContent.slice(0, SIGNATURE_MAX_LENGTH),
      isDefault: true,
    });
  }

  return list;
}

export function findSignatureById(list, signatureId) {
  if (!signatureId && signatureId !== 0) return null;
  return list.find((entry) => String(entry.id) === String(signatureId)) || null;
}

export function resolveDefaultSignatureId(list, explicitDefaultId = null) {
  if (!Array.isArray(list) || !list.length) return null;

  if (explicitDefaultId !== undefined && explicitDefaultId !== null) {
    const match = findSignatureById(list, explicitDefaultId);
    if (match) return match.id;
  }

  const flagged = list.find((entry) => entry.isDefault);
  if (flagged) return flagged.id;

  return list[0].id;
}
